import { CheckboxItemNode } from './checkbox-tree.model';
import { Tags } from './activities.model';

export interface SideNavFeature extends Tags {
  name: string;
  title?: string;
  visible?: boolean;
  active?: boolean;
  disable?: boolean;
  help?: string;
  customize?: CheckboxItemNode[];
  amountCustom?: number;
}

export interface PlatformResource {
  title: string;
  link: string;
  image: string;
}
